module.exports = {
    expandDistance: 8,
};
